import React from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import APITest from "../pages/APITest";
import CSRSummary from "../pages/csr/Summary";
import LaySummary from "../pages/csr/LaySummary";
import CSRFileUpload from "../pages/csr/FileUpload";
import LSQuestions from "../pages/csr/LSQuestions";
import SelectStudy from "../pages/csr/SelectStudy";
import DataMapping from "../pages/csr/DataMapping";
import CSRFile from "../pages/csr/File";
import LaySummaryFile from "../pages/csr/LaySummaryFile";
import StandardPharmacokinetics from "../pages/csr/StandardPharmacokinetics";
import ComparativePharmacokinetics from "../pages/csr/ComparativePharmacokinetics";
import Pharmacodynamics from "../pages/csr/Pharmacodynamics";
import StandardPharmacodynamics from "../pages/csr/StandardPharmacodynamics";
import ComparativePharmacodynamics from "../pages/csr/ComparativePharmacodynamics";
import Bioavailability from "../pages/csr/Bioavailability";
import StudyDesignDemographics from "../pages/csr/StudyDesignDemographics";
import EfficacyAnalysis from "../pages/csr/EfficacyAnalysis";
import SafetyAnalysis from "../pages/csr/SafetyAnalysis";
import AdvancedSearch from "../pages/csr/AdvancedSearch";
import TableAnalysisQuestions from "../pages/csr/TableAnalysisQuestions";
import TableAnalysisAIResponse from "../pages/csr/TableAnalysisAIResponse";
import TriloChat from "../pages/TriloChat";
import CsrProvider from "../contexts/CsrProvider";
import QuestionsProvider from "../contexts/QuestionsProvider";
import ProtectedComponent from "../utils/ProtectedComponent";
import { FeatureFlagProvider } from "../contexts/FeatureFlagContext";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<FeatureFlagProvider />}>
        <Route element={<CsrProvider />}>
          <Route
            path="dashboard"
            element={<ProtectedComponent component={Dashboard} />}
          />
          <Route
            path="trilochat"
            element={<ProtectedComponent component={TriloChat} />}
          />
          <Route
            path="trilochat/:studyId"
            element={<ProtectedComponent component={TriloChat} />}
          />
          <Route
            path="apitest"
            element={<ProtectedComponent component={APITest} />}
          />
          <Route path="csr">
            <Route index element={<NotFound />} />
            <Route path=":studyId">
              <Route index element={<NotFound />} />
              <Route
                path="summary"
                element={<ProtectedComponent component={CSRSummary} />}
              />
              <Route
                path="select-study"
                element={<ProtectedComponent component={SelectStudy} />}
              />
              <Route
                path="lay-summary"
                element={<ProtectedComponent component={LaySummary} />}
              />
              <Route
                path="file-upload"
                element={<ProtectedComponent component={CSRFileUpload} />}
              />
              <Route element={<QuestionsProvider />}>
                <Route
                  path="study-design-demographics"
                  element={
                    <ProtectedComponent component={StudyDesignDemographics} />
                  }
                />
                <Route
                  path="efficacy-analysis"
                  element={<ProtectedComponent component={EfficacyAnalysis} />}
                />
                <Route
                  path="safety-analysis"
                  element={<ProtectedComponent component={SafetyAnalysis} />}
                />
                <Route
                  path="stdpharmacokinetics"
                  element={
                    <ProtectedComponent component={StandardPharmacokinetics} />
                  }
                />
                <Route
                  path="comppharmacokinetics"
                  element={
                    <ProtectedComponent
                      component={ComparativePharmacokinetics}
                    />
                  }
                />
                <Route
                  path="pharmacodynamics"
                  element={<ProtectedComponent component={Pharmacodynamics} />}
                />
                <Route
                  path="stdpharmacodynamics"
                  element={
                    <ProtectedComponent component={StandardPharmacodynamics} />
                  }
                />
                <Route
                  path="comppharmacodynamics"
                  element={
                    <ProtectedComponent
                      component={ComparativePharmacodynamics}
                    />
                  }
                />
                <Route
                  path="bioavailability"
                  element={<ProtectedComponent component={Bioavailability} />}
                />
              </Route>
              <Route element={<QuestionsProvider />}>
                <Route
                  path="lay-summary-questions"
                  element={<ProtectedComponent component={LSQuestions} />}
                />
              </Route>
              <Route element={<QuestionsProvider />}>
                <Route
                  path="data-mapping"
                  element={<ProtectedComponent component={DataMapping} />}
                />
              </Route>
              <Route
                path="file"
                element={<ProtectedComponent component={CSRFile} />}
              />
              <Route
                path="lay-summary-file"
                element={<ProtectedComponent component={LaySummaryFile} />}
              />
              <Route
                path="advancedsearch"
                element={<ProtectedComponent component={AdvancedSearch} />}
              />
              <Route element={<QuestionsProvider />}>
                <Route
                  path="table-analysis-questions/:tableId"
                  element={
                    <ProtectedComponent component={TableAnalysisQuestions} />
                  }
                />
              </Route>
              <Route
                path="table-analysis-ai-response/:tableId"
                element={
                  <ProtectedComponent component={TableAnalysisAIResponse} />
                }
              />
            </Route>
            <Route
              path="new/summary"
              element={<ProtectedComponent component={CSRSummary} />}
            />
            <Route
              path="new/select-study"
              element={<ProtectedComponent component={SelectStudy} />}
            />
          </Route>
          <Route path="ls">
            <Route index element={<NotFound />} />
            <Route path=":studyId">
              <Route index element={<NotFound />} />
              <Route
                path="select-study"
                element={<ProtectedComponent component={SelectStudy} />}
              />
              <Route
                path="lay-summary"
                element={<ProtectedComponent component={LaySummary} />}
              />
              <Route element={<QuestionsProvider />}>
                <Route
                  path="lay-summary-questions"
                  element={<ProtectedComponent component={LSQuestions} />}
                />
              </Route>
              <Route
                path="lay-summary-file"
                element={<ProtectedComponent component={LaySummaryFile} />}
              />
            </Route>
            <Route
              path="new/select-study"
              element={<ProtectedComponent component={SelectStudy} />}
            />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRoutes;
